import 'antd/dist/reset.css';
import { QueryClientProvider } from '@tanstack/react-query';
import { PostHogProvider } from 'posthog-js/react';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import './config/axiosConfig';
import { queryClient } from './config/queryClient';
import { DownloadDock } from './domain/vendor/components/DownloadDock';
import AppRoutes from './router/router';
import './styles/message.css';

const rootElement = document.getElementById('root');

// Only initialize PostHog in production
const isProduction = process.env.REACT_APP_ENV === 'production';
const postHogKey = process.env.REACT_APP_POSTHOG_KEY;
const postHogHost = process.env.REACT_APP_POSTHOG_HOST;

// Check if PostHog should be enabled (production + valid config)
const shouldEnablePostHog = isProduction && postHogKey && postHogHost;
// const shouldEnablePostHog = true;

if (rootElement) {
  const root = ReactDOM.createRoot(rootElement as HTMLElement);

  const AppContent = (
    <QueryClientProvider client={queryClient}>
      <Router>
        <AppRoutes />
        <DownloadDock />
      </Router>
    </QueryClientProvider>
  );

  root.render(
    <React.StrictMode>
      {shouldEnablePostHog ? (
        <PostHogProvider
          apiKey={postHogKey as string}
          options={{
            api_host: postHogHost,
            capture_exceptions: true, // This enables capturing exceptions using Error Tracking
            debug: false, // Always false in production
          }}
        >
          {AppContent}
        </PostHogProvider>
      ) : (
        AppContent
      )}
    </React.StrictMode>
  );
} else {
  throw new Error('Root Element not found');
}
